<div class="x-section__headline" data-test-id="headline">
	<h2 class="mat-h1" tabindex="0" aria-labelledby="sr-label-verf">{{ vorgang.typ | enumToLabel: vorgangsTypen }}</h2>
</div>
<div class="x-section__subline">
	<i class="material-icons" aria-hidden="true">insert_drive_file</i>
	<h3 class="mat-body margin-right-auto">Verfügungen</h3>
	@if (vorgang | hasResourceLink: linkRel.CREATE_KORRESPONDENZ_VERFUEGUNG) {
		<schir-int-client-button-round #button
	                               (click)="openCreateKorrespondenzVerfuegungDialog()" popup="dialog"
	                               toolTip="Korrespondenz zu Vorgang anlegen"
	                               data-test-id="create-korrespondenz-verfuegung" materialIcon="email"
	                                   cssClass="focus-inwards-light schir-inline-button"/>
	}
	@if (vorgang | hasResourceLink: linkRel.CREATE_VERFUEGUNG) {
		<schir-int-client-button-round #button
	                               (click)="openCreateVerfuegungDialog()" popup="dialog"
	                               toolTip="Verfügung zu Vorgang anlegen" data-test-id="create-verfuegung"
	                               materialIcon="add"
	                                   cssClass="focus-inwards-light schir-inline-button"/>
	}
</div>
<div class="x-section__main">
	<div class="c-spinner" data-test-id="spinner" #spinner>
		<mat-spinner/>
	</div>

	@if ({ standard: verfuegungenInVorgang | async, korrespondenzen: korrespondenzVerfuegungenInVorgang | async }; as verfuegungen) {
		<ul class="c-list"
		>
		<div data-test-id="standard-verfuegungen">
			@for (verfuegung of verfuegungen.standard; track verfuegung) {
				<schir-int-client-verfuegung-in-vorgang [verfuegung]="verfuegung"/>
			}
		</div>

			@if (verfuegungen.korrespondenzen?.length > 0) {
				<div data-test-id="korrespondenz-verfuegungen">
			<li>
				<div class="x-section__subline">
					<i class="material-icons" aria-hidden="true">email</i>
					<h3 class="mat-body margin-right-auto">Anschreiben</h3>
				</div>
			</li>
					@for (verfuegung of verfuegungen.korrespondenzen; track verfuegung) {
						<schir-int-client-verfuegung-in-vorgang [verfuegung]="verfuegung"/>
					}
		</div>
			}
	</ul>
	}
</div>
<span id="sr-label-verf" class="sr-only">{{ vorgang.typ | enumToLabel: vorgangsTypen }} Verfügungen</span>
